import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const DownloadedFromChart: React.FunctionComponent = (props) => {
    return (
        <BPMChart {...props} title='Downloaded From' type='doughnut' subTitle='By Downloads'
            onRequestLoad={(options, signal) => {
                return (BPMAnalyticsAPI.get<any>('downloads/downloaded_from', options, signal))
            }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: 'from_source',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/DownloadedFromChart.tsx